import React from 'react';

import {
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import {
  forgotPasswordSubmit,
} from '../thunk';

import TextFieldComp from '@/components/TextFieldComp';
import {
  userSlice,
} from '@/domain/user/redux';
import { Password } from '@/domain/user/service/entity/valueObjects/password';

/**
 * プロパティ
 */
export type Props = {
  /** ユーザー名 */
  username: string;
}

const Reset: React.FC<Props> = ({ username }) => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
    getValues,
  } = useForm<{
    username: string;
    password: string;
    passwordConfirm: string;
    code: string;
  }>({
    defaultValues: {
      password: '',
      passwordConfirm: '',
      code: '',
    },
  });
  const onSubmit = (input: {
    username: string;
    password: string;
    passwordConfirm: string;
    code: string;
  }) => {
    dispatch(forgotPasswordSubmit({ ...input, username }));
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2 style={{ textAlign: 'center' }}>
        {username}
        のパスワードのリセット
      </h2>
      <TextFieldComp
        type={Password.type}
        control={control}
        rules={Password.validationRule}
        name={Password.key}
        label={Password.label2}
        placeholder=""
        errors={errors}
      />
      <TextFieldComp
        type={Password.type}
        control={control}
        rules={{
          ...Password.validationRule,
          validate: (value: string) => {
            const result = getValues().password !== value;
            if (result) {
              return 'パスワードが一致しません';
            }
            return null;
          },
        }}
        name="passwordConfirm"
        label={`${Password.label} (確認)`}
        placeholder=""
        errors={errors}
      />
      <TextFieldComp
        type="text"
        control={control}
        rules={{
          required: '必須項目です',
        }}
        name="code"
        label="認証コード"
        placeholder=""
        errors={errors}
      />
      <div style={{ textAlign: 'center', fontSize: '0.8em' }}>
        ユーザーID、新規パスワードとメールアドレスに送られてきた認証コードを入力しパスワードリセットボタンを押してください。
      </div>
      <div style={{ textAlign: 'center', margin: '10px 0' }}>
        <Button
          size="large"
          type="submit"
          variant="contained"
          color="primary"
        >
          パスワードのリセット
        </Button>
      </div>
      <div style={{ textAlign: 'center' }}>
        <Button size="small" onClick={() => dispatch(userSlice.actions.setMode('signin'))}>
          ログイン画面へ
        </Button>
      </div>
    </form>
  );
};

export default Reset;
